import { SiteHeader, SiteFooter } from "./SiteChrome";
import TemplateShowcase from "./TemplateShowcase";

export default function TemplatesPage() {
  return (
    <div className="page templates-page" id="top">
      <SiteHeader />
      <main>
        <section className="templates-intro shell"><a href="/">← Zpět na ONYXWEB</a><p>ONYXWEB / DESIGNOVÉ SMĚRY</p><h1>Inspirace má mnoho podob.<br /><em>Váš web bude vlastní.</em></h1><span>Osm vizuálních směrů pro první představu. Finální web stavíme kolem vaší značky, obsahu a zákazníků.</span></section>
        <TemplateShowcase />
      </main>
      <SiteFooter />
    </div>
  );
}
